import { type AnyAction, combineReducers } from 'redux';
import Immutable from 'immutable';

import {
    setAudioEnhancementLoadingForSceneGroup,
    setAudioEnhancementStatusForSceneGroup,
} from 'js/src/data/audio-enhancement/audio-enhancement-actions';
import type { AUDIO_ENHANCEMENT_TOGGLE_STATUS } from 'js/src/data/audio-enhancement/audio-enhancement-types';
import type { ImmutableMap } from 'js/src/libs/consts';
import { ImmutableFromJS } from 'js/src/libs/consts';

// this reducer controls the on/off state of the audio enhancement toggle
export function audio_enhancement_status(
    state = Immutable.Map<string, AUDIO_ENHANCEMENT_TOGGLE_STATUS>(),
    action: AnyAction,
) {
    if (setAudioEnhancementStatusForSceneGroup.match(action)) {
        return state.set(action.payload.sceneGroupId, action.payload.status);
    }

    return state;
}

// this reducer controls the loading icon for the audio enhancement controls
export function AUDIO_ENHANCEMENT_LOADING(
    state = Immutable.Map<
        string,
        ImmutableMap<{ isLoading: boolean; abortController?: AbortController }>
    >(),
    action: AnyAction,
) {
    if (setAudioEnhancementLoadingForSceneGroup.match(action)) {
        return state.set(
            action.payload.sceneGroupId,
            ImmutableFromJS({
                isLoading: action.payload.isLoading,
                abortController: action.payload.abortController,
            }),
        );
    }

    return state;
}

export const audio_enhancement = combineReducers({
    audio_enhancement_status,
    AUDIO_ENHANCEMENT_LOADING,
});

export type AudioEnhancementState = ReturnType<typeof audio_enhancement>;
